// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC } from "react";
import CartBanner from "@store/Library/Components/CartBanner";
import { useCurrentCartState } from "@toolkit/Framework/Store/Data/Carts/CartsHooks";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";
import siteMessage from "@insite/client-framework/SiteMessage";
import isCreditCardOnlyCustomer from "@store/Framework/Common/Utilities/isCreditCardOnlyCustomer";

const FreeShippingBanner: FC<WidgetProps> = props => {
    const cartDataView = useCurrentCartState().value;
    const isEligibleToPlaceOrder = getBooleanProperty(cartDataView?.properties.isEligibleToPlaceOrder);
    const isEligibleForFreeShipping = getBooleanProperty(cartDataView?.properties.isEligibleForFreeShipping);
    const isPaymentCreditCardOnly = isCreditCardOnlyCustomer(cartDataView);

    if (
        !cartDataView ||
        !isEligibleToPlaceOrder ||
        isPaymentCreditCardOnly === undefined ||
        (isPaymentCreditCardOnly && !isEligibleForFreeShipping)
    ) {
        return null;
    }

    const remainingAmountDisplay = cartDataView?.properties.remainingToFreeShippingDisplay;

    return (
        <>
            {isEligibleForFreeShipping && !remainingAmountDisplay && (
                <CartBanner label={siteMessage("Cart_EligibleFreeShippingBanner").toString()} variant="success" />
            )}
            {!isEligibleForFreeShipping && remainingAmountDisplay && (
                <CartBanner
                    label={siteMessage("Cart_NotEligibleFreeShippingBanner", remainingAmountDisplay).toString()}
                    variant="warning"
                />
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: FreeShippingBanner,
    definition: {
        group: "Common",
        displayName: "Free Shipping Banner",
        allowedContexts: ["CartPage"],
    },
};

export default widgetModule;
